import { Validators } from '@angular/forms';
import type { UntypedFormControl, ValidationErrors } from '@angular/forms';
import type { I18nService } from '@ppl/i18n';

export const passwordFormConfiguration = (i18nService: I18nService) => ({
  password1: ['', [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH), Validators.maxLength(PASSWORD_MAX_LENGTH), passwordPatternMatcher]] as [string, any?],
  password2: ['', [Validators.required, Validators.minLength(PASSWORD_MIN_LENGTH), Validators.maxLength(PASSWORD_MAX_LENGTH), passwordPatternMatcher, passwordsMatchValidator(i18nService)]] as [string, any?]
});

export function passwordsMatchValidator(i18nService: I18nService) {
  return function (
    control: UntypedFormControl
  ): ValidationErrors | null {
    if (!control || !control.parent) {
      return null;
    }

    const firstPasswordControl = control.parent.get('password1');
    const changePasswordControl = control.parent.get('changePassword');

    if (!firstPasswordControl) {
      console.error('first password control not present on form!');
      return null;
    }

    if (!!changePasswordControl && !changePasswordControl.value) {
      return null;
    }

    const password1Value = firstPasswordControl.value;
    const password2Value = control.value;

    if (password1Value !== password2Value) {
      return {
        'passwords-do-not-match': i18nService.translate('Passwords_do_not_match')
      };
    } else {
      return null;
    }
  };
}


/**
 * at least one lower case character
 * at least one upper case character
 * at least one number character
 *  8 characters minimum
 */
export function passwordPatternMatcher(control: UntypedFormControl): { [s: string]: boolean } {
  const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/;
  return !pattern.test(control.value) ? { 'password': true } : null;
}

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;
